/**
 * @file The Column InUsedBy component.
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../../base/columns/column-base/column-base';
import { ColumnProvider } from '../../base/column-provider';
import { DomainService } from '../../domain.service';
import { EntityQuery } from 'breeze-client';
import { ComponentRegistry } from '../../core/component-registry';
var ColumnInUseByComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnInUseByComponent, _super);
    /**
     * Creates an instance of ColumnInUseByComponent.
     * @param {ColumnProvider} provider Provides the configuration information for the column.
     * @param {ChangeDetectorRef} changeDetector Used for update optimisation
     */
    function ColumnInUseByComponent(provider, changeDetector, domainService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.domainService = domainService;
        _this.resources = [];
        var entity = _this.provider.entity;
        if (entity == null) {
            return _this;
        }
        var format = provider.field.format;
        if (!format) {
            throw new Error('Column inuseby has as no format');
        }
        var dataSource = format.dataSource;
        if (!dataSource) {
            throw new Error('Column inuseby has as no datasource');
        }
        var query = EntityQuery.from(dataSource);
        query.parameters = {
            className: entity.entityType.shortName,
            oid: entity['Oid'],
            impClass: 'Resource'
        };
        _this.domainService.entityManager.executeQuery(query).then(function (response) {
            _this.resources = response.results;
            _this.changeDetector.detectChanges();
        });
        return _this;
    }
    /**
     * Register this column class for the column provider.
     * @static
     */
    ColumnInUseByComponent.register = function () {
        ComponentRegistry.register('column', 'inuseby', ColumnInUseByComponent);
    };
    Object.defineProperty(ColumnInUseByComponent.prototype, "number", {
        get: function () {
            return this.resources.length;
        },
        enumerable: true,
        configurable: true
    });
    return ColumnInUseByComponent;
}(ColumnBase));
export { ColumnInUseByComponent };
